const imageArrayToImgContent = (imageContent) => {
	let images = imageContent
	if (Array.isArray(images)) {
		if (Array.isArray(images[0])) {
			images = images[0]
		}
	}
	return images
}

export default imageArrayToImgContent



// WEBPACK FOOTER //
// ./src/utilities/Data/imageArrayToImgContent.js